import React from "react"
import { Currency } from "../../util/numbers"
import { PayoutData } from "./types"
import { td, tdLabel } from "./constants"

const CashTicketsSummary: React.FC<{ payout: PayoutData }> = ({ payout }) => {
  const cashTicketsPurchased = payout.tickets_post?.cash_tickets_purchased
  const cashTicketsTotal = payout.tickets_post?.cash_tickets_total

  if (!cashTicketsPurchased && !cashTicketsTotal) return null

  return (
    <>
      <p className="text-sm text-gray-500 italic mt-4">
        Cash Tickets are informational only, and just here to help with the math. They do not
        effect your payout.
      </p>
      <table className="w-full table-fixed">
        <colgroup>
          <col className="w-[20%]" />
          <col className="w-[20%]" />
          <col className="w-[25%]" />
          <col className="w-[15%]" />
          <col className="w-[20%]" />
        </colgroup>
        <tbody>
          <tr>
            <td className={tdLabel} colSpan={4}>Cash Tickets Sold</td>
            <td className={`${td} text-right`}>{cashTicketsPurchased || 0}</td>
          </tr>
          <tr>
            <td className={tdLabel} colSpan={4}>Total Cash Taken at Door</td>
            <td className={`${td} text-right`}>{Currency(cashTicketsTotal || 0)}</td>
          </tr>
          <tr className="border-t border-gray-400">
            <td className={tdLabel} colSpan={4}>Total Payout + Cash</td>
            <td className={`${td} text-right font-bold`}>
              {Currency(payout.band_share + (cashTicketsTotal || 0))}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default CashTicketsSummary
